import React, { useState, useContext } from "react";
import base from "../../base";
import "@firebase/firestore";
import { AuthContext } from "../../Auth";
import Toast from "./Toast";

const Examination = (props) => {
  const onSubmitToast = () => {
    return <Toast></Toast>;
  };
  const id = props.id;
  const result = props.result;
  const resultId = props.resultId;

  const [editable, setEditable] = useState(result != null ? true : false);

  const [q1, setQ1] = useState(result != null ? result.quality : null);
  const [q2, setQ2] = useState(result != null ? result.rhythm : null);
  const [q3, setQ3] = useState(result != null ? result.blocks : null);
  const [q4, setQ4] = useState(result != null ? result.pwave : null);
  const [q5, setQ5] = useState(result != null ? result.tWave : null);

  const [qqwave, setQQWave] = useState(
    result != null ? result.qwavePatology : null
  );
  const [qpq, setPQ] = useState(result != null ? result.pqInterval : null);
  const [qrr, setRR] = useState(result != null ? result.rrInterval : null);
  const [qqt, setQT] = useState(result != null ? result.qtInterval : null);
  const [qstdelta, setST] = useState(result != null ? result.stDelta : null);
  const [qnote, setNote] = useState(result != null ? result.note : null);

  const { currentUser } = useContext(AuthContext);

  const putData = async () => {
    if (
      q1 != null &&
      q2 != null &&
      q3 != null &&
      q4 != null &&
      q5 != null &&
      qqwave != null &&
      qpq != null &&
      qpq != "" &&
      qrr != null &&
      qrr != "" &&
      qqt != null &&
      qqt != "" &&
      qstdelta != null &&
      qstdelta != ""
    ) {
      if (qstdelta >= 0 && qstdelta < 10) {
        //window.alert("Udalo sie dodac badanie");
        onSubmitToast();
        let data = null;
        const db = base.firestore();

        if (editable == true) {
          data = await db
            .collection("results")
            .doc(resultId)
            .set(
              {
                quality: parseInt(q1, 10),
                rhythm: parseInt(q2, 10),
                blocks: parseInt(q3, 10),
                pwave: parseInt(q4, 10),
                tWave: parseInt(q5, 10),
                pqInterval: parseInt(qpq, 10),
                rrInterval: parseInt(qrr, 10),
                qtInterval: parseInt(qqt, 10),
                stDelta: parseInt(qstdelta, 10),
                qwavePatology: qqwave,
                note: qnote,
                doctor: currentUser.email,
              },
              { merge: true }
            );

          await db
            .collection("requests")
            .doc(id)
            .set({ status: "done" }, { merge: true });
          window.location = "/";
        } else {
          data = await db.collection("results").add({
            quality: parseInt(q1, 10),
            rhythm: parseInt(q2, 10),
            blocks: parseInt(q3, 10),
            pwave: parseInt(q4, 10),
            tWave: parseInt(q5, 10),
            pqInterval: parseInt(qpq, 10),
            rrInterval: parseInt(qrr, 10),
            qtInterval: parseInt(qqt, 10),
            qwavePatology: qqwave,
            stDelta: parseInt(qstdelta, 10),
            note: qnote,
            doctor: currentUser.email,
          });

          await db
            .collection("requests")
            .doc(id)
            .set({ status: "done", result: data }, { merge: true });

          window.location = "/";
        }
      } else {
        window.alert("ST Delta MUSI PRZYJMOWAC WARTOSCI OD 0 do 9");
      }
    } else {
      window.alert("PROSZĘ O WYPEŁNIENIE WSZYSTKICH PÓL");
    }
  };

  return (
    <form>
      <div className="container-form">
        <h2 className="text-center m-3">Quality of ECG recording </h2>
        <div className="container-radiobutton">
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="quality"
                id="good"
                value="0"
                checked={0 == q1 ? true : false}
                onChange={() => setQ1(0)}
              ></input>
              Good (brak artefaktów, możliwa ocena większości załamków we
              wszystkich odprowadzeniach)
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="quality"
                id="acceptable"
                value="1"
                checked={1 == q1 ? true : false}
                onChange={() => setQ1(1)}
              ></input>
              Acceptable (artefakty ruchowe; możliwość analizy min 3 beatów)
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check ">
              <input
                class="form-check-input"
                type="radio"
                name="quality"
                id="poor"
                value="2"
                checked={2 == q1 ? true : false}
                onChange={() => setQ1(2)}
              ></input>
              Poor (brak odprowadzeń, zamienione odprowadzenia; możliwość
              analizy mniej niż 3 beatów)
            </div>
          </label>
        </div>

        <h2 className="text-center m-3">Rytm </h2>
        <div className="container-radiobutton">
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="normal-sinus"
                value="0"
                checked={0 == q2 ? true : false}
                onChange={() => setQ2(0)}
              ></input>
              Normal sinus rhythm
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="sinus-tachycardia"
                value="1"
                checked={1 == q2 ? true : false}
                onChange={() => setQ2(1)}
              ></input>
              Sinus tachycardia
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check ">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="wandering-pacemaker"
                value="2"
                checked={2 == q2 ? true : false}
                onChange={() => setQ2(2)}
              ></input>
              Wandering pacemaker
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="sinus-arrythmia"
                value="3"
                checked={3 == q2 ? true : false}
                onChange={() => setQ2(3)}
              ></input>
              Sinus arrythmia
            </div>
          </label>

          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="svt"
                value="4"
                checked={4 == q2 ? true : false}
                onChange={() => setQ2(4)}
              ></input>
              SVT
            </div>
          </label>

          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="artial-fibrillation"
                value="5"
                checked={5 == q2 ? true : false}
                onChange={() => setQ2(5)}
              ></input>
              Atrial fibrillation
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="artial-flutter"
                value="6"
                checked={6 == q2 ? true : false}
                onChange={() => setQ2(6)}
              ></input>
              Atrial flutter
            </div>
          </label>

          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="junctional-rhythm"
                value="7"
                checked={7 == q2 ? true : false}
                onChange={() => setQ2(7)}
              ></input>
              Junctional rhythm
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="vetrivular-tachycardia"
                value="8"
                checked={8 == q2 ? true : false}
                onChange={() => setQ2(8)}
              ></input>
              Ventrivular tachycardia
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="pacer-rhythm"
                value="9"
                checked={9 == q2 ? true : false}
                onChange={() => setQ2(9)}
              ></input>
              Pacer rhythm
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="rhythm"
                id="avrt"
                value="10"
                checked={10 == q2 ? true : false}
                onChange={() => setQ2(10)}
              ></input>
              AVRT
            </div>
          </label>
        </div>

        <h2 className="text-center m-3">Blocks </h2>
        <div className="container-radiobutton">
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="blocks"
                id="1st"
                value="0"
                checked={0 == q3 ? true : false}
                onChange={() => setQ3(0)}
              ></input>
              1st degree AV block
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="blocks"
                id="2nd-wenckebach"
                value="1"
                checked={1 == q3 ? true : false}
                onChange={() => setQ3(1)}
              ></input>
              2nd degree AV block (type 1, Wenckebach)
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="blocks"
                id="2nd-normal"
                value="2"
                checked={2 == q3 ? true : false}
                onChange={() => setQ3(2)}
              ></input>
              2nd degree AV block (type 2)
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="blocks"
                id="3rd"
                value="3"
                checked={3 == q3 ? true : false}
                onChange={() => setQ3(3)}
              ></input>
              3rd degree AV block
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="blocks"
                id="none"
                value="4"
                checked={4 == q3 ? true : false}
                onChange={() => setQ3(4)}
              ></input>
              none
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="blocks"
                id="other"
                value="5"
                checked={5 == q3 ? true : false}
                onChange={() => setQ3(5)}
              ></input>
              other
            </div>
          </label>
        </div>

        <h2 className="text-center m-3">P-wave </h2>
        <div className="container-radiobutton">
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="pwave"
                id="right"
                value="0"
                checked={0 == q4 ? true : false}
                onChange={() => setQ4(0)}
              ></input>
              right atrial enlargement
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="pwave"
                id="left"
                value="1"
                checked={1 == q4 ? true : false}
                onChange={() => setQ4(1)}
              ></input>
              left atrial enlargement
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="pwave"
                id="normal"
                value="2"
                checked={2 == q4 ? true : false}
                onChange={() => setQ4(2)}
              ></input>
              normal
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="pwave"
                id="other"
                value="3"
                checked={3 == q4 ? true : false}
                onChange={() => setQ4(3)}
              ></input>
              other
            </div>
          </label>
        </div>

        <h2 className="text-center m-3">T-wave </h2>
        <div className="container-radiobutton">
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="twave"
                id="positive"
                value="0"
                checked={0 == q5 ? true : false}
                onChange={() => setQ5(0)}
              ></input>
              positive
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="twave"
                id="inverted"
                value="1"
                checked={1 == q5 ? true : false}
                onChange={() => setQ5(1)}
              ></input>
              inverted
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="twave"
                id="isoelectric"
                value="2"
                checked={2 == q5 ? true : false}
                onChange={() => setQ5(2)}
              ></input>
              isoelectric
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="twave"
                id="hyperacute"
                value="3"
                checked={3 == q5 ? true : false}
                onChange={() => setQ5(3)}
              ></input>
              hyperacute/peaked
            </div>
          </label>
        </div>

        <h2 className="text-center m-3">Q Wave Pathology </h2>
        <div className="container-radiobutton">
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="qwavePath"
                id="true"
                value="true"
                checked={true === qqwave ? true : false}
                onChange={() => setQQWave(true)}
              ></input>
              True
            </div>
          </label>
          <label className="radiobutton">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="qwavePath"
                id="false"
                value="false"
                checked={false == qqwave ? true : false}
                onChange={() => setQQWave(false)}
              ></input>
              False
            </div>
          </label>
        </div>

        <h2 className="text-center m-3">PQ Interval </h2>
        <div class="form-group form-control-numeric">
          <label for="example-text-input" class="col-2 col-form-label"></label>

          <input
            class="form-control "
            type="number"
            id="pqinterwal"
            placeholder="Type Number"
            value={qpq}
            onChange={(e) => setPQ(e.target.value)}
          />
        </div>

        <h2 className="text-center m-3">RR Interval </h2>
        <div class="form-group form-control-numeric">
          <label for="example-text-input" class="col-2 col-form-label"></label>

          <input
            class="form-control"
            type="number"
            id="rrinterval"
            placeholder="Type Number"
            value={qrr}
            onChange={(e) => setRR(e.target.value)}
          />
        </div>

        <h2 className="text-center m-3">QT Interval </h2>
        <div class="form-group form-control-numeric">
          <label for="example-text-input" class="col-2 col-form-label"></label>

          <input
            class="form-control "
            type="number"
            id="qtinterval"
            placeholder="Type Number"
            value={qqt}
            onChange={(e) => setQT(e.target.value)}
          />
        </div>

        <h2 className="text-center m-3">ST Delta</h2>
        <div class="form-group form-control-numeric">
          <label for="example-text-input" class="col-2 col-form-label"></label>

          <input
            class="form-control"
            type="number"
            id="stdelta"
            placeholder="Type Number"
            value={qstdelta}
            onChange={(e) => setST(e.target.value)}
          />
        </div>

        <h2 className="text-center m-3">Notatka</h2>
        <div class="form-group">
          <label for="example-text-input" class="col-2 col-form-label"></label>

          <textarea
            class="form-control form-control-textarea"
            type="text"
            id="note"
            placeholder="Type text"
            value={qnote}
            onChange={(e) => setNote(e.target.value)}
          />
        </div>

        <div className="form-stickyPlace">
          <button
            type="button"
            class="form-stickyButton  mt-2"
            onClick={() => {
              putData();
            }}
          >
            Wyslij opis
          </button>
        </div>
      </div>
    </form>
  );
};

export default Examination;
